import {
  Routes,
  Route,
  Navigate 
} from "react-router-dom";
import { useContext, useState } from "react"; 
import { GlobalStates } from "../GlobalStates";
import Main from "../Routes/Login";
import MaintenanceMode from "../Components/MaintenanceMode";
import Form from "../Routes/Form";
import FormTable from "../Routes/FormTable";
import Users from "../Routes/Users";
import { Creator } from "../Routes/Creator";
import CreatorTable from "../Routes/CreatorTable";
import StatistikaTable from "../Routes/Rezultatai";
import Tendencijos from "../Routes/Tendencijos";
import Profile from "../Routes/Profile";
import CreateImone from "../Routes/CreateImone";
import Policies from "../Routes/Policies";
import Statistika from "../Routes/Statistika";
import { RemindPass } from "../Routes/RemindPass";
import NewPass from "../Routes/NewPass";
import EmailConfirmation from "../Routes/EmailConfirmation";
// import RequestPasswordReset from "../Components/Auth/RequestPasswordReset"; // Using OTP version instead
import RequestPasswordResetOTP from "../Components/Auth/RequestPasswordResetOTP";
import PasswordResetConfirmation from "../Components/Auth/PasswordResetConfirmation";
// import NewPassword from "../Components/Auth/NewPassword"; - Component does not exist

const Navigation = () => {
  const { user, userStatus, isLoading } = useContext(GlobalStates); // Added userStatus, removed type
  
  // Corrected isAdmin logic: Check admin_confirmed from userStatus (result of check_account_status RPC)
  const isAdmin = userStatus?.admin_confirmed === true;
  
  const [isMaintenanceMode] = useState(process.env.REACT_APP_MAINTENANCE_MODE === "true");

  if (isMaintenanceMode) {
    return <MaintenanceMode />;
  }
  
  if (isLoading) { 
    return (
      <div className="auth-loading-container">
        <div className="auth-loading-spinner"></div>
      </div>
    );
  }

  // Always defined routes that don't depend on authentication state
  const publicRoutes = (
    <>
      <Route path="/" element={user === null ? <Main /> : (isAdmin ? <Users /> : <FormTable />)} />
      <Route path="/login" element={user === null ? <Main /> : <Navigate to="/" replace />} />
      <Route path={"/Įmonės apklausos/:id"} element={<Form />} /> 
      <Route path={"/Formos/:id"} element={<Form />} /> 
      <Route path={"/PrivatumoPolitikaIrTaisykles"} element={<Policies />} />
      <Route path={"/NaujasSlaptazodis"} element={<NewPass />} />
      <Route path={"/PrimintiSlaptazodi"} element={<RequestPasswordResetOTP />} />
      <Route path={"/confirm-password-reset"} element={<PasswordResetConfirmation />} />
      <Route path={"/email-confirmation"} element={<EmailConfirmation />} />
      <Route path={"/auth/recovery"} element={<NewPass />} />
    </>
  );

  // Routes that require the user to be logged in
  const authenticatedRoutes = user !== null ? (
    <>
      <Route path={"/Profilis"} element={<Profile />} />
      
      {isAdmin ? (
        // Admin-only routes
        <>
          <Route path={"/Tendencijos"} element={<Tendencijos />} />
          <Route path={"/Rezultatai"} element={<StatistikaTable />} />
          <Route path={"/Apklausos"} element={<CreatorTable />} />
          <Route path={"/Apklausos/:id"} element={<Creator />} />
          <Route path={"/Imones"} element={<Users />} />
          <Route path={"/Statistika"} element={<Statistika />} />
          <Route path={"/ImonesApklausos"} element={<FormTable />} />
          <Route path={"/SukurtiImone"} element={<CreateImone />} />
        </>
      ) : (
        // Normal authenticated user routes 
        <>
          <Route path={"/Tendencijos"} element={<Tendencijos />} />
          <Route path={"/Rezultatai"} element={<StatistikaTable />} />
          <Route path={"/ImonesApklausos"} element={<FormTable />} />
        </>
      )}
    </>
  ) : null;

  // Redirect catchall route
  const redirectRoute = (
    <Route path="*" element={<Navigate to={user ? "/" : "/login"} replace />} />
  );

  return (
    <div className="routaiCont">
      <Routes>
        {publicRoutes}
        {authenticatedRoutes}
        {redirectRoute}
      </Routes>
    </div>
  );
};

export default Navigation;
